export const filterString = (rows:any, columnIds:any, filterOpts: any):boolean => {
	const dbLoc = filterOpts.meta.databaseLocation ?? columnIds;
	const { value } = filterOpts;
	return value.length === 1 ? value[0] === rows.original[dbLoc] : value.includes(rows.original[dbLoc]);
}
